export function obterListaMdfeTipoEmissao() {
  return (
    [
      { label: '1 - Normal', value: 'NORMAL' },
      { label: '2 - Contingência off-line', value: 'CONTINGENCIA' },
      { label: '3 - Regime Especial NFF', value: 'NFF' },
    ]
  );
}
